var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_960_8887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75537 7.10788L3.81641 6.23779V12.6671C3.81646 12.7369 3.83028 12.806 3.85706 12.8706C3.88385 12.9351 3.92307 12.9937 3.9725 13.043C4.02193 13.0924 4.0806 13.1315 4.14515 13.1582C4.2097 13.1848 4.27887 13.1985 4.34872 13.1985H12.8711C12.941 13.1987 13.0103 13.185 13.0749 13.1584C13.1396 13.1318 13.1984 13.0927 13.2479 13.0433C13.2974 12.994 13.3367 12.9353 13.3636 12.8708C13.3904 12.8062 13.4042 12.737 13.4043 12.6671V10.2982L8.75537 7.10788Z",
    fill: "#1F6A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75537 1.59766H4.34872C4.27887 1.5976 4.2097 1.6113 4.14515 1.63797C4.0806 1.66465 4.02193 1.70377 3.9725 1.75312C3.92307 1.80247 3.88385 1.86107 3.85706 1.92557C3.83028 1.99008 3.81646 2.05923 3.81641 2.12908V4.49794L8.75537 7.39822L11.3705 8.26831L13.4043 7.39822V4.49794L8.75537 1.59766Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.81641 4.49756H8.75537V7.39784H3.81641V4.49756Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.35118 3.91699H3.81641V11.1677H7.35118C7.49203 11.167 7.62693 11.1108 7.72666 11.0114C7.82638 10.9119 7.88289 10.7771 7.88394 10.6363V4.44841C7.88289 4.30757 7.82638 4.17281 7.72666 4.07334C7.62693 3.97386 7.49203 3.91769 7.35118 3.91699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.06071 4.20752H3.81641V11.4582H7.06071C7.20156 11.4575 7.33646 11.4014 7.43618 11.3019C7.5359 11.2024 7.59241 11.0677 7.59347 10.9268V4.73894C7.59241 4.59809 7.5359 4.46333 7.43618 4.36386C7.33646 4.26439 7.20156 4.20822 7.06071 4.20752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.06071 4.20752H3.81641V10.8782H7.06071C7.20156 10.8775 7.33646 10.8213 7.43618 10.7218C7.5359 10.6224 7.59241 10.4876 7.59347 10.3468V4.73894C7.59241 4.59809 7.5359 4.46333 7.43618 4.36386C7.33646 4.26439 7.20156 4.20822 7.06071 4.20752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.77023 4.20752H3.81641V10.8782H6.77023C6.91108 10.8775 7.04598 10.8213 7.14571 10.7218C7.24543 10.6224 7.30194 10.4876 7.30299 10.3468V4.73894C7.30194 4.59809 7.24543 4.46333 7.14571 4.36386C7.04598 4.26439 6.91108 4.20822 6.77023 4.20752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.44389 4.20752H6.7706C6.9117 4.2074 7.04708 4.26331 7.14697 4.36296C7.24687 4.46261 7.30312 4.59784 7.30336 4.73894V10.0567C7.30312 10.1978 7.24687 10.3331 7.14697 10.4327C7.04708 10.5324 6.9117 10.5883 6.7706 10.5881H1.44389C1.37401 10.5883 1.30479 10.5746 1.24018 10.548C1.17558 10.5213 1.11686 10.4822 1.06739 10.4328C1.01791 10.3835 0.978643 10.3249 0.951832 10.2603C0.925021 10.1958 0.911191 10.1266 0.911133 10.0567V4.73894C0.911191 4.66906 0.925021 4.59987 0.951832 4.53534C0.978643 4.4708 1.01791 4.41218 1.06739 4.36283C1.11686 4.31347 1.17558 4.27436 1.24018 4.24771C1.30479 4.22106 1.37401 4.2074 1.44389 4.20752Z",
    fill: "url(#paint0_linear_960_8887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5625 9.12519L3.6829 7.39216L2.65665 5.66895H3.48077L4.04075 6.77239C4.09251 6.8768 4.12999 6.95444 4.14695 7.0062H4.15453C4.19112 6.92231 4.22994 6.84155 4.27054 6.76258L4.86934 5.67073H5.62788L4.5753 7.38413L5.65465 9.12653H4.84748L4.20049 7.91689C4.17045 7.86488 4.14492 7.81039 4.12419 7.75403H4.11348C4.09462 7.80895 4.06946 7.8615 4.03852 7.91064L3.37235 9.12519H2.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.872 1.59766H8.75586V4.49794H13.4048V2.12908C13.4047 2.05919 13.3909 1.99001 13.3641 1.92547C13.3373 1.86094 13.298 1.80232 13.2485 1.75296C13.1991 1.70361 13.1403 1.66449 13.0757 1.63784C13.0111 1.6112 12.9419 1.59754 12.872 1.59766Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75586 7.39795H13.4048V10.2982H8.75586V7.39795Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_960_8887",
    x1: 2.02395,
    y1: 3.78988,
    x2: 6.19054,
    y2: 11.0058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_960_8887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2783,
    height: 14.2783,
    fill: "white",
    transform: "translate(0.0195312 0.258301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/ExcelIcon.cf7984df304d2061cafdebc58a971740.svg";
export { ForwardRef as ReactComponent };